export default {
  text: '{{threshold}} vânzări lunare: {{amount}}',
  label: '{{threshold}} vânzări lunare:',
  no_discount: 'fără reducere',
  discount_badge: '-{{percentage}}%',
};
